import React from "react";
import "./inputTextfield.scss";

const InputTextfield = ({
    label,
    value,
    onChange,
    placeholder = "Enter text",
    rows = 4,
    required = false,
}) => {
    return (
        <div className="text-field">
            {label && (
                <label className="text-field__label">
                    {label}
                    {required && (
                        <span className="text-field__required">*</span>
                    )}
                </label>
            )}
            <div className="text-field__wrapper">
                <textarea
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    className={`text-field__textarea ${
                        value ? "text-field__textarea--filled" : ""
                    }`}
                    rows={rows}
                    required={required}
                />
            </div>
        </div>
    );
};

export default InputTextfield;
